const api = {
  baseUrl: 'https://odontoagenda-api.herokuapp.com',
}

module.exports = api;